import { c as _c } from "react/compiler-runtime";
import { Button } from '@common/components';
import { Image } from '@/components/client';
interface PointEmptySectionProps {
  mainMessage: string;
  subMessage?: string;
  actionButton?: {
    text: string;
    onClick: VoidFunction;
  };
}
export const PointEmptySection = t0 => {
  const $ = _c(11);
  const {
    mainMessage,
    subMessage,
    actionButton
  } = t0;
  let t1;
  if ($[0] !== mainMessage) {
    t1 = <strong className="font-700 text-Gray-900 typo-body2">{mainMessage}</strong>;
    $[0] = mainMessage;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Image alt={"\uCF54\uC778"} className="my-8" height={90} src="/assets/pngs/silver-coin.png" width={90} unoptimized={true} />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== subMessage) {
    t3 = subMessage ? <p className="whitespace-pre-wrap font-400 text-Gray-600 typo-body4">{subMessage}</p> : null;
    $[3] = subMessage;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== actionButton) {
    t4 = actionButton ? <Button className="mt-20" onClick={actionButton.onClick}>{actionButton.text}</Button> : null;
    $[5] = actionButton;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t1 || $[8] !== t3 || $[9] !== t4) {
    t5 = <section className="flex-col break-keep px-20 py-24 text-center flex-center">{t1}{t2}{t3}{t4}</section>;
    $[7] = t1;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};